import { FILTER_MODE_CONTAINS } from '../../utils/constant';

export type ActionTableFilterParamsType = {
  filterColumn: string;
  filterMode: number;
  filterText: string;
};

export const defaultActionTableFilterParams: ActionTableFilterParamsType = {
  filterColumn: '',
  filterMode: FILTER_MODE_CONTAINS,
  filterText: '',
};
